import * as React from 'react';

import { CloseButtonWidget } from '@tableau/widgets';
import { Messages } from '../../../codegen/Localize';
import { AngularDirective } from '../../../common/react/components/AngularDirective';
import { imgPath } from '../../../common/utilities/ImgUrl';
import { IVizPreviewScope } from '../../../ts/controllers/VizPreviewCtrl';
import { AngularContext } from '../../../ts/factories/AngularContextFactory';

export class DevicePreviewModal extends React.PureComponent<DevicePreviewModal.Props> {

  private readonly setupDevicePreviewScope = (scope: ng.IScope): IVizPreviewScope => {
    const vizPreviewScope = scope as IVizPreviewScope;
    return vizPreviewScope;
  }

  private closeButton(): JSX.Element {
    // TFS 840752: In IE11, it is necessary to supply a "height" style to the button in order to
    // have the flex CSS center the icon vertically. It actually doesn't matter what the "height"
    // value actually is, so long as it is smaller than the "min-height" (which is automatically
    // supplied by ButtonWidget).
    // See this for more info: https://stackoverflow.com/a/25386261
    const buttonStyle: React.CSSProperties = {
      float: 'right',
      cursor: 'pointer',
      height: 0
    };
    const testId = 'device-preview-close';
    const buttonWidgetProps = {
      handleClick: this.props.dismiss,
      testId: testId,
      style: buttonStyle,
      useDarkStyling: true,
    };

    return (
      <CloseButtonWidget {...buttonWidgetProps}/>
    );
  }

  public render(): JSX.Element {
    const template = `<tb:device-preview viz-path="${this.props.vizPath}"></tb:device-preview>`;

    return (
    <React.Fragment>
      {this.closeButton()}
      <AngularDirective
        setupScope={this.setupDevicePreviewScope}
        angularContext={this.props.angularContext}
        template={template}
      />
    </React.Fragment>);
  }
}

export namespace DevicePreviewModal {
  export interface Props {
    readonly angularContext: AngularContext;
    readonly vizPath: string;
    readonly dismiss: () => void;
  }
}
